import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserService } from '../../../../services/user/user.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent {

 userProfile: any = null;

  constructor(private UserService: UserService) {}

  ngOnInit(): void {
    this.UserService.getUserInfo().subscribe(
      (data) => {
        this.userProfile = {
          name: data["custom:nombre"] || "No disponible",
          id: data["custom:numeroDoc"] || "No disponible",
          role: data["custom:cargo"] || "No disponible",
          photo: data["custom:photo"] || "usuario.webp"
        };
      },
      (error) => {
        console.error('Error obteniendo datos del usuario:', error);
      }
    );
  }

}
